import React, { FunctionComponent, useContext } from 'react'

import { ConfirmationModal } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import checkmark from 'assets/icons/check-gray-bg.svg'
import { ActionType, PageName } from 'generated/types'
import trackEvent from 'utils/analytics/trackEvent'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { FunnelContext } from 'utils/FunnelContext'
import { ModalActionTypes } from 'utils/prompts'

import {
  ReferralDisclosureAllSetButtonTappedEvent,
  ReferralDisclosureAllSetContainerViewedEvent,
} from './events'

type Props = {
  isOpen: boolean
}

type InnerProps = Props & WithFlowRouterProps

const StyledConfirmationModal = styled(ConfirmationModal)`
  max-width: 700px;
  width: calc(100% - 40px);
`

const TextContainer = styled.div`
  padding: 0 5px;
`

const Text = styled.p`
  margin: 0;
  line-height: 22px;

  &:last-child {
    margin-top: 20px;
    margin-bottom: 25px;
  }
`

const SuccessModalComponent = (props: InnerProps) => {
  const { isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)
  const { getRemoteString } = useRemoteStrings()
  const handleCloseModal = () => {
    trackEvent('Button Tapped', {
      eventData: ReferralDisclosureAllSetButtonTappedEvent,
    })

    isDynamicFunnelEnabled
      ? routeToPage(PageName.ReferralDisclosure, ActionType.Continue)
      : props.route({ from: FlowRoute.ReferralDisclosure, action: 'continue' })
  }

  const onOpenComplete = () => {
    trackEvent('Container Viewed', {
      eventData: ReferralDisclosureAllSetContainerViewedEvent,
    })
  }

  const message = (
    <TextContainer>
      <Text>{getRemoteString({ key: 'referral_disclosure.modal.body' })}</Text>
      <Text>{getRemoteString({ key: 'referral_disclosure.modal.body2' })}</Text>
    </TextContainer>
  )

  return (
    <StyledConfirmationModal
      onRequestClose={() => null}
      onOpenComplete={onOpenComplete}
      isOpen={props.isOpen}
      actions={[
        {
          label: getRemoteString({ key: 'referral_disclosure.modal.cta' }),
          type: ModalActionTypes.primary,
          handler: handleCloseModal,
        },
      ]}
      title={getRemoteString({ key: 'referral_disclosure.modal.title' })}
      image={checkmark}
      eventFields={{
        object_name: 'referralDisclosureSuccessModal',
        screen_name: 'referralDisclosure',
        screen: 'referralDisclosure',
      }}
      message={message}
    />
  )
}

export const SuccessModal = withFlowRouter(SuccessModalComponent as FunctionComponent)
